import { MARS_LAYER } from 'foundations-components/transitional/constants';
export const DELETE_COMMENT_POPOVER_ID = 'delete-comment-popover';
export const MINI_COMMENTER_ID = 'mini-commenter-popover';
export const COLLAPSED_SIDEBAR_WIDTH = 43;
export const FLOATING_COLLAPSED_SIDEBAR_WIDTH = 56;
export const FLOATING_COLLAPSED_SIDEBAR_WIDTH_WITH_PADDING = FLOATING_COLLAPSED_SIDEBAR_WIDTH + 10;
export const MIN_SIDEBAR_WIDTH = 466;
export const MAX_SIDEBAR_WIDTH = 500;
export const COMPACT_FLOATING_COLLAPSED_SIDEBAR_WIDTH = 48;
export const SIDEBAR_ANIMATION_DURATION_SECONDS = 0.5;
export const SIDEBAR_ANIMATION_DURATION_MILLISECONDS = SIDEBAR_ANIMATION_DURATION_SECONDS * 1000;
export const COMPACT_ICON_SPACING = '200';
export const COMPACT_BUTTON_SIZE = 'sm';
export const COMPACT_ICON_SIZE = '300';
export const COMPACT_DRAG_HANDLE_SIZE = '32px';
export const DEFAULT_DRAG_HANDLE_SIZE = '40px';
export const DEFAULT_ICON_SPACING = '500';
export const PREFER_CURRENT_DROP_AREA_BUFFER = 56;

// Drop preview sizing (approximate pixel values for the preview indicator)
// left/right (vertical) placement
export const DROP_PREVIEW_ICON_HEIGHT = 34;
export const DROP_PREVIEW_ICON_MARGIN = 25;
export const COMPACT_DROP_PREVIEW_ICON_HEIGHT = 28;
export const COMPACT_DROP_PREVIEW_ICON_MARGIN = 14;
// top/bottom (horizontal) placement
export const DROP_PREVIEW_BASE_PADDING = 10;
export const DROP_PREVIEW_HORIZONTAL_MARGIN = 20;
export const DROP_PREVIEW_ICON_WIDTH = 50;
export const COMPACT_DROP_PREVIEW_BASE_PADDING = 6;
export const COMPACT_DROP_PREVIEW_HORIZONTAL_MARGIN = 16;
export const COMPACT_DROP_PREVIEW_ICON_WIDTH = 42;
export const FLOATING_SIDEBAR_Z_INDEX = Number.parseInt(MARS_LAYER, 10);
export const COMMENT_LIST_PADDING_PX = 16;
export const THREAD_INDENT_PX = 14;
export const MAX_COMMENT_LIST_HEIGHT = 390;